<finxone-web-frontend-desktop-listing
  [entityData]="paymentRequestData"
  [actionOptions]="actionOptions"
  [dataIn]="dataIn"
  [pageNumber]="pageNumber"
  [totalListCount]="totalListCount"
  (pageChange)="onPageChange($event)"
  emptyTableMsg="No History Found"
  (searchValueText)="searchValue($event)"
  [actionButtonContent]="actionButton"
  [confirmButtonStyle]="confirmButtonStyle"
  [actionDropdownStyle]="actionDropdownStyle"
  [showConfirmButton]="showConfirmButton"
  [dropdownOptions]="dropdownOptions"
  (rowData)="rowData($event)"
  (checkboxSelection)="storeSelectedItemsIds($event)"
  (tableHeaderCheckboxSelection)="processSelectedItemsAndStoreIds($event)"
  (dropDownValue)="dropDownValueChange($event)"
  (confirmButtonAction)="onConfirm($event)"
  [enableClickableRow]="enableClickableRow"
  [selectedOption]="selectedOption"
  [dropdownAction]="dropdownAction"
></finxone-web-frontend-desktop-listing>
